import { Box, Container, Heading, List, ListIcon, ListItem, Text, VStack, Code } from '@chakra-ui/react'
import { FiCheck } from 'react-icons/fi'

export const ApiWarehousePage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="xl" color="brand.500" mb={3}>
            API: складской контур
          </Heading>
          <Text color="gray.600">
            Эндпоинты склада: справочники, остатки, резервы и движения материалов.
          </Text>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Группы эндпоинтов</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/warehouse/categories</Code> — категории и типы материалов.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/warehouse/materials</Code> — карточки материалов.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/warehouse/movements</Code> — приходы, списания, перемещения.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/warehouse/reserves</Code> — резервы под работы/объекты.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/warehouse/requests</Code> — заявки и их статусы.</ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  )
}
